import { render } from "./ListeArrondissementPage.vue?vue&type=template&id=7e822964&ts=true"
import script from "./ListeArrondissementPage.vue?vue&type=script&lang=ts"
export * from "./ListeArrondissementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__